import { createPostEndpoint } from '@sonar-software/sonar-http';

export type PostOnboardingEnrollRequest = {
	customerName: string;
	email: string;
	firstName: string;
	lastName: string;
	password: string;
	shardCategory?: string;
};

export type PostOnboardingEnrollResponse = {
	userIdToken: string;
};

export const postOnboardingEnroll = createPostEndpoint<PostOnboardingEnrollRequest, PostOnboardingEnrollResponse>(
	'/api/v3/core/onboarding/enroll'
);
